import React from 'react';
import ImageLoader from '../../ImageLoader';
import Member from '../../Member';
import { HalalIcon, LoaderIcon } from '../../../../utils/svg';
import Voucher from '../Voucher';
import OperationalHour from '../OperationalHour';
import Address from '../Address';
import Location from '../Location';
import TableNumber from '../TableNumber';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { UFOODX_BASE_URL } from '../../../../utils/constants';
import { cleanText, isEmptyData } from '../../../../utils/helper';
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline';

const StoreClosed = ({ outlet }) => {
	if (!outlet?.outletOpenTime) return null;

	return (
		<div
			className='flex items-center gap-2 px-4 py-3 rounded-t-md'
			style={{ backgroundColor: '#FDEFDC' }}
		>
			<BuildingStorefrontIcon className='w-5 h-5 text-gray-500 shrink-0' />
			<p className='text-xs text-gray-500'>
				<span className='font-bold text-gray-700'>Maaf, toko ini sedang tutup. </span>
				Pesan untuk pukul {outlet?.outletOpenTime}
			</p>
		</div>
	);
};

const Detail = (props) => {
	const { name = '', image = '', isOpen = '0', tableNumber = '' } = props;
	const { details: outlet } = useSelector((store) => store?.outlet);
	const { selectedOrderType } = useSelector((store) => store?.order);
	const type = cleanText(selectedOrderType?.av_name);

	const location = useLocation();
	const isRoot = new RegExp(`^${UFOODX_BASE_URL}/?$`).test(location.pathname);

	const isClosed = !Boolean(isOpen) || isOpen === '0';

	return (
		<div className='h-full'>
			<div className='sticky top-0 -translate-y-4 z-[2]'>
				<div className='bg-white mt-4 pb-2 rounded-md shadow-custom'>
					{isClosed && <StoreClosed outlet={outlet} />}
					<div className={`relative ${isClosed ? 'pointer-events-none' : ''}`}>
						{isClosed && (
							<div className='absolute inset-0 bg-white/60 z-[1] rounded-b-md' />
						)}

						<Member />
						{type === 'delivery' && !isRoot && <Location />}

						<div className='flex items-center py-3 px-4'>
							<ImageLoader
								src={image}
								alt={name}
								className='aspect-[1/1] w-11 h-auto object-fill rounded-full'
							/>
							<div className='pl-4 space-y-2'>
								<div className='font-semibold text-base text-gray-700'>{name}</div>
								<div className='flex xxs:items-center gap-1 flex-col xxs:flex-row'>
									{Boolean(isOpen) && (
										<div className='flex items-center gap-1'>
											<OperationalHour />
										</div>
									)}
									<div className='flex items-center gap-1'>
										<HalalIcon />
										<div className='font-medium text-xxs text-gray-700'>
											{outlet?.restaurant_type || 'Indonesian Food'}
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className='border-t-1 border-solid border-gray-200 mx-4' />
						<Address />
						<Voucher />

						{type === 'dinein' && !isRoot && !isEmptyData(outlet?.dinein_qr_code) && (
							<>
								<div className='border-t-1 border-solid border-gray-200 mx-4' />
								<TableNumber tableNumber={tableNumber} />
							</>
						)}
					</div>

				</div>
			</div>
		</div>
	);
};

export default Detail;